import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getIfIsaAccountSelector } from "@state/ifIsa/ifIsa.selectors";
import { investorSelector } from "@state/investor/investor.selectors";

export const useHasAccessToIfIsa = () => {
  const ifIsaAccount = useSelector(getIfIsaAccountSelector);
  const hasIfIsaAccount = Boolean(ifIsaAccount && ifIsaAccount?.id);
  const investor = useSelector(investorSelector);

  const hasUkTaxResidency = useMemo(
    () =>
      investor?.taxResidencies?.some(
        (taxResidency) =>
          taxResidency.jurisdiction === "GB" &&
          !taxResidency.deletedAt &&
          taxResidency.doesNotIssueTin === false
      ),
    [investor]
  );

  return Boolean(hasUkTaxResidency) || hasIfIsaAccount;
};
